import React, { useState, useEffect, Fragment } from 'react';
import axios from 'axios'; // Assuming you're using axios for API calls
import ExceptionsList from './ExceptionsList';
import { fetchOrderExceptiosn, fetchOrderNotifications } from '../../api/OrdersApi';
import I18n from '../../common/I18n';
import NotificationList from './NotificationList';
import { Col, Row, Timeline } from 'antd';
import { isEmpty } from '../../common/Common';
import { momentTimeWithShortName } from '../../helpers/date_functions';

const OrderNotifications = ({ currentOrder, currentOrg, isMilitaryTime, fromIndividualScreen }) => {
  const [notificationLog, setNotificationLog] = useState([]);


  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        if (currentOrder?.id) {
          const response = await fetchOrderNotifications(currentOrder.id);
          if(response.success){
            setNotificationLog(response.data || [])
            

          } else {
            
            setNotificationLog([])
          }
        }
      } catch (error) {
        console.error('Error fetching exceptions:', error);
      }
    };
    fetchNotifications();
  }, [currentOrder?.id]);

  return (
    <div>
      <NotificationList
            isMilitaryTime={isMilitaryTime}
            data={notificationLog}
            size="small"
            pagination={{ position: 'none' }}
            timeZone={currentOrder.timeZoneId}
            timeZoneName={currentOrder.tz_short_name}
            rowKey={(record) => record.id}
            expandedRowRender={(record) => (
                <Fragment>
                  <Row>
                    <Col span={24}>
                      <div className="marginTop10 marginBottom15">
                        <span className="textBold">{I18n.t('general.message')}:</span>
                        &nbsp;&nbsp;
                        <span className="fontSize13">
                    {record.notification_msg_body}
                  </span>
                      </div>
                      {!isEmpty(record.status_logs) && _.isArray(record.status_logs) && (
                          <div>
                            <Timeline>
                              {record.status_logs.map((errLog, index) => {
                                const hasErr = !isEmpty(errLog.error)
                                return (
                                    <Timeline.Item
                                        color={hasErr ? 'red' : 'blue'}
                                        key={index}
                                    >
                            <span className="textCaptilize fontSize12">
                              {errLog.status}
                              {hasErr
                                  ? ` (${I18n.t(
                                      `sms.error_codes.${errLog.error}`,
                                  )})`
                                  : ''}
                              {errLog.tracked_at && (
                                  <span>
                                  &nbsp; on &nbsp;
                                    {momentTimeWithShortName(
                                        isMilitaryTime
                                            ? 'MMM D, YYYY HH:mm'
                                            : 'lll',
                                        errLog.tracked_at,
                                        currentOrder.order_timeZoneId,
                                        currentOrder.order_tz_short_name,
                                    )}
                                </span>
                              )}
                            </span>
                                    </Timeline.Item>
                                )
                              })}
                            </Timeline>
                          </div>
                      )}
                      {/* <StatusLogList
                  data={!isEmpty(record.status_logs) && _.isArray(record.status_logs)? record.status_logs :[]}
                  pagination={{ position: "none" }}
                  size="small"
                  timeZone={currentOrder.order_timeZoneId}
                  timeZoneName={currentOrder.order_tz_short_name}
                /> */}
                    </Col>
                  </Row>
                </Fragment>
            )}
            scroll = {{y: fromIndividualScreen ? "calc(100vh - 290px)" : "calc(100vh - 180px)"}}
        />
      
    </div>
  );
};

export default OrderNotifications;
